// Snooze configuration constants
export const SnoozeType = Object.freeze({
  CONTROL: "control",
  MISCONFIGURATION: "misconfiguration",
  AFFECTED_ENTITY: "affected_entity",
});

export const SNOOZE_PERIODS = [
  { value: 7, label: "7 days" },
  { value: 30, label: "30 days" },
  { value: 90, label: "3 months" },
  { value: 365, label: "1 year" },
  { value: "date", label: "Custom" },
];

export const SNOOZE_REASONS = [
  "Incorrect Data",
  "Risk Accepted",
  "Not Relevant",
  "Custom...",
];

export const CUSTOM_REASON_OPTION = "Custom...";

export const MAX_SNOOZE_DAYS = 365;
export const MIN_SNOOZE_DAYS = 1;

export const SNOOZE_REASON_MAX_LENGTH = 100;

export const DURATION_TYPES = {
  PRESET: "preset",
  DATE: "date",
};

export const REASON_TYPES = {
  PRESET: "preset",
  CUSTOM: "custom",
};
